import { render, staticRenderFns } from "./coSeller.vue?vue&type=template&id=7a381f78&scoped=true"
import script from "./coSeller.vue?vue&type=script&lang=js"
export * from "./coSeller.vue?vue&type=script&lang=js"
import style0 from "./coSeller.vue?vue&type=style&index=0&id=7a381f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a381f78",
  null
  
)

export default component.exports